/**
 * Form state + validação + build do request — Create Anonymization (POST).
 *
 * Espelha o CreateAnonymizationDtoSchema real (Zod): entityType (1..100),
 * entityId (min 1) e level (enum) obrigatórios; documentReferenceId opcional.
 * NÃO há campo `reason` no DTO real (o prompt de kickoff citava `reason` — drift;
 * o backend não o aceita). `tenant-all` é bloqueado na validação.
 */

import type { AnonymizationLevel, CreateAnonymizationRequest } from './types';

export interface AnonymizationFormState {
  entityType: string;
  entityId: string;
  level: AnonymizationLevel;
  documentReferenceId: string;
}

export function initialAnonymizationForm(): AnonymizationFormState {
  return {
    entityType: 'person',
    entityId: '',
    level: 'contextual',
    documentReferenceId: '',
  };
}

export function validateAnonymizationForm(form: AnonymizationFormState): string | null {
  if (form.entityType.trim() === '') return 'Selecione o tipo de entidade.';
  if (form.entityType.trim() === 'tenant-all') {
    return 'Anonimização tenant-wide não é permitida aqui — use uma solicitação LGPD formal (B1).';
  }
  if (form.entityId.trim() === '') return 'Informe o ID da entidade a anonimizar.';
  return null;
}

export function buildCreateRequest(form: AnonymizationFormState): CreateAnonymizationRequest {
  const req: CreateAnonymizationRequest = {
    entityType: form.entityType.trim(),
    entityId: form.entityId.trim(),
    level: form.level,
  };
  if (form.documentReferenceId.trim() !== '') {
    req.documentReferenceId = form.documentReferenceId.trim();
  }
  return req;
}
